import { createRequest as e, Client as t } from "@urql/core";

export * from "@urql/core";

import { make as r, subscribe as a, scan as o, switchMap as n, never as i, concat as s, fromValue as u, map as c } from "wonka";

import { writable as v, derived as l } from "svelte/store";

import { getContext as p, setContext as x } from "svelte";

var fromStore = e => r((t => e.subscribe(t.next)));

var f = {
  operation: void 0,
  fetching: !1,
  data: void 0,
  error: void 0,
  extensions: void 0,
  hasNext: !1,
  stale: !1
};

var createPausable = e => ({
  isPaused$: e,
  pause() {
    e.set(!0);
  },
  resume() {
    e.set(!1);
  }
});

function queryStore(t) {
  var r = e(t.query, t.variables);
  var p = {
    requestPolicy: t.requestPolicy,
    ...t.context
  };
  var x = t.client.createRequestOperation("query", r, p);
  var d = v(x);
  var q = {
    ...f,
    operation: x
  };
  var h = v(!!t.pause);
  var b = v(q, (() => a((e => {
    b.set(e);
  }))(o(((e, t) => ({
    ...e,
    ...t
  })), q)(n((e => {
    if (e) {
      return i;
    }
    return n((e => s([ u({
      fetching: !0,
      stale: !1,
      hasNext: !1
    }), c((({stale: e, data: t, error: r, extensions: a, operation: o, hasNext: n}) => ({
      fetching: !1,
      stale: !!e,
      data: t,
      error: r,
      operation: o,
      extensions: a,
      hasNext: n
    })))(t.client.executeRequestOperation(e)), u({
      fetching: !1,
      hasNext: !1
    }) ])))(fromStore(d));
  }))(fromStore(h)))).unsubscribe));
  return {
    ...l(b, ((e, t) => {
      t(e);
    })),
    ...createPausable(h),
    reexecute: e => {
      var a = {
        ...e,
        ...t.context
      };
      var o = t.client.createRequestOperation("query", r, a);
      h.set(!1);
      d.set(o);
    }
  };
}

function mutationStore(t) {
  var r = e(t.query, t.variables);
  var n = t.client.createRequestOperation("mutation", r, t.context);
  var i = {
    ...f,
    operation: n,
    fetching: !0
  };
  var s = v(i);
  var u = a((e => {
    s.set(e);
  }))(o(((e, t) => ({
    ...e,
    ...t
  })), i)(c((({stale: e, data: t, error: r, extensions: a, operation: o, hasNext: n}) => ({
    fetching: !1,
    stale: e,
    data: t,
    error: r,
    operation: o,
    extensions: a,
    hasNext: n
  })))(t.client.executeRequestOperation(n))));
  return l(s, ((e, t) => {
    t(e);
    return u.unsubscribe;
  }));
}

function subscriptionStore(t, r) {
  var p = e(t.query, t.variables);
  var x = t.client.createRequestOperation("subscription", p, t.context);
  var d = {
    ...f,
    operation: x,
    fetching: !0
  };
  var q = v(!!t.pause);
  var h = v(d, (() => a((e => {
    h.set(e);
  }))(o(((e, t) => {
    var a = null != t.data ? "function" == typeof r ? r(e.data, t.data) : t.data : e.data;
    return {
      ...e,
      ...t,
      data: a
    };
  }), d)(n((e => {
    if (e) {
      return i;
    }
    return s([ u({
      fetching: !0,
      stale: !1
    }), c((({stale: e, data: t, error: r, extensions: a, operation: o}) => ({
      fetching: !0,
      stale: !!e,
      data: t,
      error: r,
      operation: o,
      extensions: a
    })))(t.client.executeRequestOperation(x)), u({
      fetching: !1
    }) ]);
  }))(fromStore(q)))).unsubscribe));
  return {
    ...l(h, ((e, t) => {
      t(e);
    })),
    ...createPausable(q)
  };
}

var d = "$$_urql";

var getContextClient = () => {
  var e = p(d);
  if ("production" !== process.env.NODE_ENV && !e) {
    throw new Error("No urql Client was found in Svelte context. Did you forget to call setContextClient?");
  }
  return e;
};

var setContextClient = e => {
  x(d, e);
};

var initContextClient = e => {
  var r = new t(e);
  setContextClient(r);
  return r;
};

export { getContextClient, initContextClient, mutationStore, queryStore, setContextClient, subscriptionStore };
//# sourceMappingURL=urql-svelte.mjs.map
